import type { LinkComponent } from '@tanstack/react-router';
import { createLink } from '@tanstack/react-router';
import clsx from 'clsx';

export type VanillaLinkProps = React.ComponentPropsWithRef<'a'> &
  Record<`data-${string}`, unknown> & {
    block?: boolean;
    plain?: boolean;
    underline?: boolean | 'hover';
  };

export function VanillaLink({ block, plain, underline, ...otherProps }: VanillaLinkProps) {
  return (
    <a
      {...otherProps}
      className={clsx(
        block && 'block',
        !plain && 'font-medium text-primary-600 hover:text-primary-500',
        underline === true && 'underline',
        underline === 'hover' && 'hover:underline',
        otherProps?.className
      )}
      rel={otherProps.target ? 'noopener noreferrer' : otherProps.rel}
    />
  );
}

const CreatedLink = createLink(VanillaLink);

export const Link: LinkComponent<typeof VanillaLink> = props => <CreatedLink {...props} />;
